// pages/CareersPage.tsx
import React from "react";
import styled from "styled-components";

const CareersContainer = styled.div`
  text-align: center;
  min-height: 70vh;
  padding: 0px 20px 25px 20px;
`;

const Title = styled.h1`
  color: #71a4aa;
  font-family: "Cursive Dumont", cursive;
  margin-bottom: 30px;
`;

const CareerCard = styled.div`
  background: #fff;
  margin: 20px auto;
  padding: 20px;
  border-radius: 10px;
  max-width: 600px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  
  &:hover {
    transform: scale(1.02);
  }
`;

const CareersPage: React.FC = () => {
  return (
    <CareersContainer>
      <Title>Candidatures spontanées et stages</Title>
      <CareerCard>
        <p>
          Vous êtes passionné(e) par la petite enfance ? Rejoignez notre équipe !
          Nous acceptons les candidatures spontanées et proposons des stages en lien
          avec notre activité.
        </p>
        <p>
          Pour postuler, veuillez envoyer votre CV et lettre de motivation à l'adresse suivante : <strong>melimelo59630@gmail.com</strong>
        </p>
      </CareerCard>
    </CareersContainer>
  );
};

export default CareersPage;
